var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":"","fill-height":""}},[_c('v-row',{attrs:{"justify":"center"}},[_c('v-col',{staticClass:"flex-grow-0 text-center"},[_c('v-img',{class:[
          'banana',
          {
            'speen': _vm.isSpeen
          }
        ],attrs:{"src":"/img/high-quality-banana.png","max-height":"300","max-width":"300"}}),_c('v-btn',{attrs:{"large":"","color":"primary"},on:{"click":function($event){_vm.isSpeen = !_vm.isSpeen}}},[_vm._v(" "+_vm._s(_vm.isSpeen ? 'no!' : 'speen')+" ")])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }